import useAppContext from '@groupefungo/react-apollo.core/app/UseContext';

export default () => {
  const { gql } = useAppContext();

  const InspirationsStylesFragment = gql`
fragment InspirationsStyleFragment on InspirationsStyle {
  id
  gid
  styleName
  styleNotes
}
  `;
  // eslint-disable-next-line import/prefer-default-export
  const InspirationFragment = gql`
fragment InspirationFragment on Inspiration {
    id
    title
    pinterestLink
    style
    notes
    fabricIds
    colorIds
}
`;

  return {
    InspirationFragment,
  };
};
